import React, { useContext, useEffect, useState } from "react";
import RightArrow from "../../../../../images/ArrowRight.svg";

import { MapsContext } from "../../maps/context/context";
import { mapsPayloadType } from "../../maps/context/reducer";
import { JunctionStatus } from "../../../../../utils/Enum.types";
import { useLazyQuery } from "@apollo/client";
import { GetDashboardJunctionStatusCount } from "./queries";
import {
  GetDashboardJunctionStatusCountData,
  GetDashboardJunctionStatusCountVars,
} from "./types";
import {
  convertEnumToLabels,
  junctionStatusIcons,
} from "../../../../../utils/UtilFunctions";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import { pollingMinutes } from "../../../../../utils/constants";
interface Props {
  setJunctionDetals: React.Dispatch<React.SetStateAction<boolean>>;
  setJunctionType: React.Dispatch<React.SetStateAction<JunctionStatus | null>>;
}

interface JunctionStatusItemType {
  label: string;
  count: number;
  icon: string;
  value: JunctionStatus;
}
const JunctionStatusCount = ({ setJunctionDetals, setJunctionType }: Props) => {
  const [junctionsList, setJunctionsList] = useState<JunctionStatusItemType[]>(
    []
  );

  const { customer_id } = useUrlParams();

  const { user_details } = useLoggedInUserDetails();
  const [GetDashBoard, { data }] = useLazyQuery<
    GetDashboardJunctionStatusCountData,
    GetDashboardJunctionStatusCountVars
  >(GetDashboardJunctionStatusCount,{
    pollInterval : pollingMinutes
  });

  useEffect(() => {
    if (customer_id && user_details.id)
      GetDashBoard({
        variables: {
          customerID: customer_id,
          empID: user_details.id,
        },
      }).then(({ data }) => {
        if (data && data.GetDashboardJunctionStatusCount) {
          const junctionsList = data.GetDashboardJunctionStatusCount.map(
            (res) => {
              return {
                label: convertEnumToLabels(res.junctionStatus),
                count: res.count,
                icon: junctionStatusIcons[res.junctionStatus],
                value: res.junctionStatus as JunctionStatus,
              };
            }
          );
          setJunctionsList(junctionsList);
        }
      });
  }, [GetDashBoard, data]);

  return (
    <div className="d-junctions-status-count">
      <b className="d-main-page__block--title">Signal Status</b>
      <ul className="d-junctions-status-count__ul">
        {junctionsList.map((res, index) => {
          return (
            <li
              onClick={() => {
                setJunctionDetals(true);
                setJunctionType(res.value);
              }}
            >
              <div className="d-ticket-details--flex">
                <span>{index + 1}.</span>
                <img
                  src={res.icon}
                  alt="/"
                  className={`img-icon__${res.label}`}
                />
                <label>{res.label}</label>
              </div>
              <div className="d-ticket-details--flex">
                <b>{res.count}</b>
                <img src={RightArrow} alt="" />
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default JunctionStatusCount;
